<template>
  <div>
    <b-card>
      <div class="d-flex flex-wrap">
        <h4>Список классификаторов направлений</h4>
        <b-button
          variant="primary"
          @click="onAddDirectionGroup"
          class="d-block ml-auto"
        >
          Добавить
        </b-button>
      </div>
      <div class="ag-grid-olympics-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="ag-theme-material h-100"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
        >
        </ag-grid-vue>
      </div>
    </b-card>
    <DeleteModal
      id="deleteDirectionGroupModal"
      title="Подтверждение удаления классификатора направления"
      @delete="onDeleteConfirm"
    >
      {{ deleteText }}
    </DeleteModal>
    <EditDirectionGroupModal :editData="selected" @save="onSaveDirectionGroup" />
  </div>
</template>

<script>
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { clientWidthType } from '@/config/config'
import AgGridFactory from '@/components/helpers/factory/agGrid'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
import EditDirectionGroupModal from '@/components/admin/modals/recommendations/EditDirectionGroupModal.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'DirectionGroups',
  components: {
    AgGridVue,
    DeleteModal,
    EditDirectionGroupModal
  },
  data() {
    return {
      gridOptions: AgGridFactory.getGridOptionsDefault(),
      columnDefs: [
        {
          headerName: 'Код',
          field: 'code',
          width: 100,
          suppressSizeToFit: true
        },
        {
          headerName: 'Название',
          field: 'title',
          minWidth: 100,
          width: 350
        },
        AgGridFactory.getDefaultActionRenderer({
          onEdit: this.onEditClick,
          onDelete: this.onDeleteClick
        })
      ],
      rowData: [],
      gridApi: null,
      deleteText: 'При удалении классификатора направлений будут также '
        + 'удалены соответствующие направления. Вы подтверждаете удаление?',
      selected: null
    }
  },
  async created() {
    await this.updateDirectionGroups()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridSizeChanged()
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.TIGHT) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    async updateDirectionGroups() {
      const response = await RecommendationAPI.getDirectionGroups()
      const filterModel = this.gridOptions.api ? this.gridOptions.api.getFilterModel() : null
      const sortModel = this.gridOptions.api ? this.gridOptions.api.getSortModel() : null
      this.rowData = _.sortBy(response.data, 'code')
      this.$nextTick(() => {
        if (this.gridOptions.api) {
          this.gridOptions.api.setFilterModel(filterModel)
          this.gridOptions.api.setSortModel(sortModel)
        }
      })
    },
    onEditClick(params) {
      this.selected = params
      this.$bvModal.show('editDirectionGroupModal')
    },
    onDeleteClick(params) {
      this.selected = params
      this.$bvModal.show('deleteDirectionGroupModal')
    },
    onAddDirectionGroup() {
      this.selected = null
      this.$bvModal.show('editDirectionGroupModal')
    },
    async onDeleteConfirm() {
      await RecommendationAPI.deleteDirectionGroup(this.selected.id)
      await this.updateDirectionGroups()
    },
    async onSaveDirectionGroup(params) {
      if (params.id) {
        await RecommendationAPI.updateDirectionGroup(params)
      } else {
        await RecommendationAPI.addDirectionGroup(params)
      }
      await this.updateDirectionGroups()
    }
  }
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 230px);
}
</style>
